import React from 'react';
import { useNavigate } from 'react-router-dom';

import styled from 'styled-components';

const ReturnButtonWrapper = styled.div`
    align-items: center;
    background: #F0F0F0;
    border-radius: 1rem;
    cursor: pointer;
    display: flex;
    height: 3.5rem;
    margin-bottom: 3rem;
    padding: 0.5rem 2rem;
`;

const ReturnButtonArrow = styled.div`
    background: url('${process.env.PUBLIC_URL}/images/icons/arrow-right.svg') no-repeat center;
    background-size: cover;
    height: 0.75rem;
    margin-right: 0.5rem;
    transform: rotate(180deg);
    width: 0.75rem;
`;

const ReturnButtonText = styled.span`
    font-size: 1.125rem;
`;


const ReturnButton = () => {
    const navigate = useNavigate();

	return (
		<ReturnButtonWrapper onClick={() => navigate(-1)}>
            <ReturnButtonArrow />
            <ReturnButtonText>Voltar</ReturnButtonText>
        </ReturnButtonWrapper>
	);
}

export default ReturnButton;